import { useAuth } from "../../hooks/useAuth";
import { Navigate } from "react-router-dom";

export const RequireAuth = ({ children }) => {
    const { isLoggedIn } = useAuth();
  
    return isLoggedIn === true
      ? children
      : <Navigate to="/login" replace />;
  }